import React from 'react';
import PropTypes from 'prop-types';
import { createGlobalStyle } from 'styled-components';

import { CLARET } from '../constants/colors';
import Header from './Header';
import SEO from './Seo';

const GlobalStyle = createGlobalStyle`
  *, *::before, *::after {
    box-sizing: border-box;
  }

  body {
    font-family: Merriweather, serif;
    color: rgba(0, 0, 0, 0.85);
    -webkit-font-smoothing: antialiased;
    font-size: 16px;
    line-height: 1.625;
    margin: 0;
  }

  h1,
  h2 {
    margin:  1em 0;
  }

  h1 {
    font-size: 1.5rem;
  }

  h2 {
    font-size: 1.25rem;
  }

  h3 {
    font-weight: 300;
    font-size: 1.125rem;
  }

  p {
    margin: 1.25em 0;
  }

  ol, ul {
    font-family: Roboto, sans-serif;
    font-size: 1.125rem;
    font-weight: 300;
    margin: 0;
    padding: 1.2rem 2rem;
    background: rgba(0, 0, 0, 0.05);
  }

  li + li {
    margin-top: 0.5rem;
  }

  ul {
    list-style: none;

    li {
      padding-left: 0.8em;
      margin-left: -1em;
      position: relative;

      &::before {
        content: "•";
        position: absolute;
        left: 0;
      }
    }
  }

  hr {
    margin: 1em 0;
  }

  pre[class*="language-"] {
    font-size: 0.875em;
  }

  :not(pre) > code[class*="language-"] {
    font-size: 0.9em;
    background: rgba(0, 0, 0, 0.1);
    padding: 0.2em 0.5em;
    color: initial;
    font-family: monospace;
  }

  a {
    color: ${CLARET};
    text-decoration: none;
    font-weight: 500;
  }

  figure {
    margin-left: 0;
    margin-right: 0;
  }

  img {
    max-width: 100%;
  }

  figcaption {
    font-family: Roboto, sans-serif;
    text-align: center;
    margin: 0.5rem 0;
    font-size: 0.875rem;
    opacity: 0.5;
  }

  main {
    margin-bottom: 5rem;
  }

  iframe {
    margin: 0 -100px;
    width: calc(100% + 200px) !important;
  }

  @media (max-width: 1000px) {
    ol, ul {
      margin-left: 0;
      margin-right: 0;
    }

    iframe {
      margin: 0;
      width: 100% !important;
    }
  }
`;

const Layout = ({ children, seo }) => (
  <>
    <GlobalStyle />
    <SEO {...seo} />
    <Header />
    <main>{children}</main>
  </>
);

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  seo: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    thumbnail: PropTypes.string,
  }),
};

export default Layout;
